import mutations from '@/store/modules/wsm/wsmCommonState/wsm.mutations';
import actions from '@/store/modules/wsm/wsmCommonState/wsm.actions';
import getters from '@/store/modules/wsm/wsmCommonState/wsm.getters';
import WSMTypes from '@/store/modules/wsm/wsmTypes';
import { KeyLabel } from '@/store/mutations-typesCommon';
import { Service } from '@/utils/types/global';
export interface State {
  currentWSMType: KeyLabel;
  wsmServices: Array<KeyLabel>;
  currentWSMService: Service;
}

const initialState: State = {
  currentWSMType: WSMTypes[0],
  wsmServices: [],
  currentWSMService: { key: '', label: '', permissions: [] }
};

export default {
  namespaced: true,
  state: initialState,
  mutations: mutations,
  actions: actions,
  getters: getters
};
